import { render, staticRenderFns } from "./ArticleDetailView.vue?vue&type=template&id=15dcf3fb&scoped=true&"
import script from "./ArticleDetailView.vue?vue&type=script&lang=js&"
export * from "./ArticleDetailView.vue?vue&type=script&lang=js&"
import style0 from "./ArticleDetailView.vue?vue&type=style&index=0&id=15dcf3fb&lang=scss&scoped=true&"
import style1 from "./ArticleDetailView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dcf3fb",
  null
  
)

export default component.exports